import { render } from "./localizedFormField.vue?vue&type=template&id=279451b4&scoped=true&ts=true"
import script from "./localizedFormField.vue?vue&type=script&lang=ts"
export * from "./localizedFormField.vue?vue&type=script&lang=ts"

import "./localizedFormField.vue?vue&type=style&index=0&id=279451b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279451b4"]])

export default __exports__